module.exports = __webpack_public_path__ + "static/media/taboola.33347a31.svg";